
define('text!modules/campaign/pixelSegment/templates/bin_group_name.html',[],function () { return '<div class="pixel_type_icon">{{pixel_type}}</div><div class="group-c">&nbsp;{{bin_group_name}}</div>';});

